import { RecaptchaRequest } from '@accredible-frontend-v2/recaptcha';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RecipientPortalApiService } from '../rp-api.service';

@Injectable({ providedIn: 'root' })
export class InviteExpiredService extends RecipientPortalApiService {
  resetInvite(captchaToken: string, token: string): Observable<void> {
    const body = {
      token,
      [RecaptchaRequest.V2]: captchaToken,
    };

    return this._post('/v1/auth/reset_invite', body).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res: HttpErrorResponse) => {
        if (res.status === 429) {
          return throwError(() => ({ status: 429 }));
        }
        return this._handleError(res);
      }),
    );
  }
}
